import React from "react";

function WaysToGiveContent() {
    return (
        <div className="main-content">
            <div className="rs-breadcrumbs breadcrumbs-overlay">
                <div className="breadcrumbs-img">
                    <img src="assets/images/ways.png" alt="Breadcrumbs " />
                </div>
                <div className="breadcrumbs-text white-color">
                    <h1 className="page-title">Ways to Give</h1>
                </div>
            </div>


            <section className="intro-section gray-bg pt-30 pb-30 md-pt-64 md-pb-70">
                <div className="container">
                    <div className="row clearfix">
                        <div className="col-lg-3">
                            <ul className="nav nav-tabs intro-tabs tabs-box flex-column" id="myTab" role="tablist">
                                <li className="nav-item tab-btns">
                                    <a className="nav-link tab-btn active" id="insurance-reviews-tab" data-toggle="tab" href="#insurance-policy" role="tab" aria-controls="insurance-policy" aria-selected="false">Wire Transfer</a>
                                </li>
                                <li className="nav-item tab-btns">
                                    <a className="nav-link tab-btn" id="gift-from-ira" data-toggle="tab" href="#gift" role="tab" aria-controls="gift-from-ira" aria-selected="false">By Cheque</a>
                                </li>
                                <li className="nav-item tab-btns">
                                    <a className="nav-link tab-btn" id="trust" data-toggle="tab" href="#trusttab" role="tab" aria-controls="trust" aria-selected="false">Interac e-transfers</a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-9">
                            <div className="tab-content tabs-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="insurance-policy" role="tabpanel" aria-labelledby="insurance-reviews-tab">
                                    <div className="content pt-20 pb-20 pl-20 pr-20 white-bg">
                                        <h4 style={{ textAlign: "center", color: "#e12323" }}>Wire Transfer</h4>
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-6">
                                                    <p style={{ textAlign: "left"}}><b>Account holder Name:  </b>Canadian Friends of IIT Madras<br/>
                                                    <b>Account Number: </b>5226327<br/>
                                                    <b>Name of the Bank: </b>The Toronto-Dominion Bank<br/>
                                                    <b>Branch Address: </b>1648 Montreal Rd Ottawa, Ontario, Ontario K1J 6N5<br/>
                                                    </p>                                                    
                                                </div>
                                                <div className="col-6">
                                                <p style={{ textAlign: "left"}}><b>Bank: </b>004<br/>
                                                    <b>Transit: </b>07946<br/>
                                                    <b>Swift Code: </b>TDOMCATTTOR<br/>
                                                    <b>Routing Code: </b>026009593<br/>
                                                    </p>                                                     
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="gift" role="tabpanel" aria-labelledby="gift-from-ira">
                                    <div className="content pt-20 pb-20 pl-20 pr-20 white-bg">
                                        <h4 style={{ textAlign: "center", color: "#e12323" }}> By Cheque</h4>
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-6">
                                                    <p><b>Please mail/courier it to:</b><br />
                                                        Dr. Venkatesh Mannar,<br />
                                                        16 Humberstone Drive Unit 101 North York ON M2N 7C1<br /></p>
                                                </div>
                                                <div className="col-6">
                                                    <p><span style={{ fontWeight: "bold" }}>Email: <span>director@cf.iitm.ac.in</span><br /><span>Phone:</span>+16137468502, +16138524955</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="trusttab" role="tabpanel" aria-labelledby="trust">
                                    <div className="content pt-20 pb-20 pl-20 pr-20 white-bg">
                                        <h4 style={{ textAlign: "center", color: "#e12323" }}>Interac e-transfers</h4>
                                        <p>
                                            e-transfers to be sent to <span style={{ fontWeight: "bold" }}>"director@cf.iitm.ac.in"</span><br />This will be automatically deposited to the account of <span style={{ fontWeight: "bold" }}>CANADIAN FRIENDS OF IIT MADRAS at TD Canada Trust</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
export default WaysToGiveContent;